export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const CLEAR_MODAL_STATE = "modal/CLEAR_MODAL_STATE";
